// extracted by mini-css-extract-plugin
export default {"container":"style_container__w2Do+","page":"style_page__zM9YK","error":"style_error__kAgVN"};